export class MissingCountryDomainError extends Error {
  constructor(message) {
    super(message);
    this.name = 'MissingCountryDomainError';
  }
}

export async function getGeocodeCloudFlarePoP(
  url = 'https://location-provider.aeq.workers.dev/'
) {
  const response = await fetch(url);
  if (response.ok) {
    return response.json();
  }
  throw new Error(response.statusText);
}

export function suggestCountryDomain(alpha2CC, countryCodeDomainMap = {}) {
  if (Object.keys(countryCodeDomainMap).length === 0) {
    throw new Error(`countryCodeDomainMap is empty. 
      Pass an object with ISO-3611-1 Alpha2 country code keys corresponding to the suggested country URL value.`);
  }

  if (alpha2CC in countryCodeDomainMap) return countryCodeDomainMap[alpha2CC];

  throw new MissingCountryDomainError(
    `The country code ${alpha2CC} was not found in the ISO3611-1 alpha2 country code to domain map. 
    Configured country codes are ${Object.keys(countryCodeDomainMap)}`
  );
}
